import { teesPropertiesObject } from '../../tools/generalProperties';
import { TeeMeasureLabel } from '../../types/databaseTables/idealteemeasures';
import { NewTeeTypesRow } from '../../types/databaseTables/newteetypes';
import { FilterObjectSlider, FilterState } from '../../types/reducers/filterReducer';
import { getFilterSettingsFromLocalStorage } from '../../utils/localStorageActions';


export function getAvailableColorsFilterObject(newTeeTypesArrayState: NewTeeTypesRow[]): Record<string, { checked: boolean; disabled: boolean }> {
    return newTeeTypesArrayState
        .reduce((acc, cur) => [...new Set(acc.concat(cur.availablecolors))], [] as string[])
        .sort()
        .reduce((acc, cur) => {
            const returnObj = { ...acc };
            returnObj[cur] = { checked: false, disabled: false };
            return returnObj;
        }, {} as Record<string, { checked: boolean; disabled: boolean }>)
}



export const initialFilterSliderObject = Object.keys(teesPropertiesObject)
    .reduce<Record<TeeMeasureLabel, FilterObjectSlider>>((acc, cur) => ({
        ...acc, [cur]: {
            min: teesPropertiesObject[cur as TeeMeasureLabel].min,
            max: teesPropertiesObject[cur as TeeMeasureLabel].max,
            disabled: false,
        }
    }), {} as Record<TeeMeasureLabel, FilterObjectSlider>);

const localStorageFilterSettings = getFilterSettingsFromLocalStorage();

export const initialFitReducerState: FilterState = {
    initialArrayOfPosts: [],
    internalFilteredGarmentObjects: [],
    externalFilteredGarmentObjects: [],
    filterCheckboxObjects: localStorageFilterSettings?.filterCheckboxObjects ||  {
        manufacturer: {},
        description: {},
        availablecolors: {},
    },
    filterSliderObjects: localStorageFilterSettings?.filterSliderObjects || initialFilterSliderObject,
    memoizedIdArrays: {
        availablecolors: [],
        description: [],
        manufacturer: [],
        armholeopening: [],
        chest: [],
        frontlength: [],
        hem: [],
        necktoshoulder: [],
        neckwidth: [],
        shouldertoshoulder: [],
        sleevelength: [],
        sleeveopening: [],
        waist: [],
        fit: [],
        reliability: [],
    },
    fit: localStorageFilterSettings?.fit || {
        disabled: false,
        min: 0,
    },
    reliability: localStorageFilterSettings?.reliability || {
        disabled: false,
        min: 50,
    },
    timestamps: {
        availablecolors: "",
        description: "",
        manufacturer: "",
        armholeopening: "",
        chest: "",
        frontlength: "",
        hem: "",
        necktoshoulder: "",
        neckwidth: "",
        shouldertoshoulder: "",
        sleevelength: "",
        sleeveopening: "",
        waist: "",
        fit: "",
        reliability: "",
        internalFilteredGarmentObjects: new Date().toUTCString(),
        externalFilteredGarmentObjects: new Date().toUTCString(),
        fetchedData: new Date().toUTCString(),
    },
};
